/* eslint-disable eqeqeq */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { useEntities } from '../helpers/selectors'
import { getVariantPath } from '../../utils/get-variant-path'
import richTextFieldHasContent from '../../utils/rich-text-has-content'
import Card from './card'
import withComponentBase from '../helpers/with-component-base'

const stylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'modules',
    componentId: 'featuredCards',
    variantName: variant,
    field,
  })

// How many rows and cols should we have depending on the number of cards
const arrangement = {
  2: { cols: 2, rows: 1 },
  3: { cols: 3, rows: 1 },
  4: { cols: 2, rows: 2 },
  5: { cols: 5, rows: 1 },
  6: { cols: 3, rows: 2 },
  7: { cols: 7, rows: 1 },
  8: { cols: 4, rows: 2 },
  9: { cols: 3, rows: 3 },
  10: { cols: 5, rows: 2 },
  11: { cols: 11, rows: 1 }, // 🥴
  12: { cols: 3, rows: 4 },
}

const removeBlankRichTextProps = (cardArray) => {
  const modifiedCards = cardArray.map((props) => {
    const { description = {}, title = {}, subHeading = {}, ...rest } = props

    return {
      ...(richTextFieldHasContent(description) ? { description } : {}),
      ...(richTextFieldHasContent(title) ? { title } : {}),
      ...(richTextFieldHasContent(subHeading) ? { subHeading } : {}),
      ...rest,
    }
  })
  return modifiedCards
}

const trimExcessPropsFromCards = (cardArray) => {
  const targetProps = cardArray[0]
  const targetPropsArr = Object.keys(targetProps || {})

  const trimmedCards = cardArray.map((card) => {
    const objectEntries = Object.entries(card)
    const filteredEntries = objectEntries.filter(([key]) => targetPropsArr.includes(key))
    return Object.fromEntries(filteredEntries)
  })
  return trimmedCards
}

const FeaturedCards = ({ cards = [] }) => {
  const cardsArray = useEntities(cards)
  const reducedCardsArray = removeBlankRichTextProps(cardsArray)
  const consistentPropsCardsArray = trimExcessPropsFromCards(reducedCardsArray)
  const variant = undefined

  const { cols, rows } = arrangement[consistentPropsCardsArray.length] || {
    cols: 1,
    rows: consistentPropsCardsArray.length,
  }

  return (
    <div
      sx={{
        variant: stylePath('wrapper', variant),
        display: 'grid',
        counterReset: 'step-counter',
      }}
    >
      <For each='row' index='i' of={Array(rows).fill()}>
        <div
          sx={{
            display: ['block', 'grid'],
            gridColumnGap: '20px',
            gridTemplateColumns: [null, `repeat(${cols}, 1fr)`],
            mb: 20,
          }}
          key={i}
        >
          <For
            each='cardProps'
            index='j'
            of={consistentPropsCardsArray.slice(i * cols, (i + 1) * cols)}
          >
            <Card key={j} {...cardProps} columnNumber={j + 1} />
          </For>
        </div>
      </For>
    </div>
  )
}

export default withComponentBase(FeaturedCards, () => ({
  withHeaderFooter: true,
  wrapHeaderFooterChildren: true,
  headerStyles: {
    textAlign: 'left',
    py: 16,
  },
  footerContainerStyles: {
    textAlign: 'center',
  },
}))
